import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales', storeModule.createStoreModule('sales'))
